module.exports = __webpack_public_path__ + "static/media/i_featured_analytic.4b2fe36a.svg";